import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiConnectCaller";

export const GET_PHONE_NUMBER = "GET_PHONE_NUMBER";
export const GET_PHONE_NUMBER_ERROR = "GET_PHONE_NUMBER_ERROR";
export const GET_PHONE_NUMBER_SUCCESS = "GET_PHONE_NUMBER_SUCCESS";

export const CHANGE_PHONE_NUMBER = "CHANGE_PHONE_NUMBER";
export const CHANGE_PHONE_NUMBER_SUCCESS = "CHANGE_PHONE_NUMBER_SUCCESS";
export const CHANGE_PHONE_NUMBER_ERROR = "CHANGE_PHONE_NUMBER_ERROR";

/**
 * Reducer
 */

const initialState = {
  phoneNumbers: [],
  error: false,
};

export const phoneNumberReducer = (state = initialState, action) => {
  // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  //     console.log(action)
  // }
  switch (action.type) {
    case GET_PHONE_NUMBER:
      return {
        ...state,
      };
    case GET_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        phoneNumbers: action.payload,
        error: false,
      };
    case GET_PHONE_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //change

    case CHANGE_PHONE_NUMBER:
      return {
        ...state,
      };

    case CHANGE_PHONE_NUMBER_SUCCESS: {
      const newData = state.phoneNumbers.items.map((b) => {
        if (b.id == action.data.phoneId) {
          b.targetType = action.data.targetType;
          b.checkCallUrl = action.data.checkCallUrl;
          b.targetId = action.data.targetId;
        }
        return b;
      });
      return {
        ...state,
        newData,
      };
    }

    case CHANGE_PHONE_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
};

/**
 * Action
 */

export const getPhoneNumberAction = () => ({
  type: GET_PHONE_NUMBER,
});

export const changePhoneNumberAction = (
  targetType,
  targetId,
  phoneId,
  checkCallUrl
) => ({
  type: CHANGE_PHONE_NUMBER,
  data: {
    targetType,
    targetId,
    phoneId,
    checkCallUrl,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPhoneNumberAction,
      changePhoneNumberAction,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getPhoneNumberApi = () => {
  return apiCaller.get(`${process.env.REACT_APP_API_CONNECT}/phonenumbers`);
};

const putChangePhoneNumberApi = (
  targetType,
  targetId,
  phoneId,
  checkCallUrl
) => {
  return apiCaller.put(
    `${process.env.REACT_APP_API_CONNECT}/phonenumbers/handler/${phoneId}`,
    {
      targetType,
      targetId,
      checkCallUrl,
    }
  );
};

/**
 * sagas
 */

export const getPhoneNumberFlow = function* () {
  while (true) {
    yield take(GET_PHONE_NUMBER);
    try {
      const res = yield call(getPhoneNumberApi);
      yield put({
        type: GET_PHONE_NUMBER_SUCCESS,
        payload: {
          ...res.data.data.items,
        },
      });
    } catch (error) {
      yield put({ type: GET_PHONE_NUMBER_ERROR, error });
    }
  }
};

export const putChangePhoneNumberFlow = function* () {
  while (true) {
    const action = yield take(CHANGE_PHONE_NUMBER);
    try {
      const res = yield call(
        putChangePhoneNumberApi,
        action.data.targetType,
        action.data.targetId,
        action.data.phoneId,
        action.data.checkCallUrl
      );
      yield put({
        type: CHANGE_PHONE_NUMBER_SUCCESS,
        payload: {
          ...res.data.data.item,
        },
      });
      console.log(res);
    } catch (error) {
      yield put({ type: CHANGE_PHONE_NUMBER_ERROR, error });
    }
  }
};
